module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/313.6cb65c47.png";